import axiosClient from './axiosClient';

export type Company = {
  id: string;
  name: string;
  system: string;
  serialNumber: string;
  masterSerialNumber: string | null;
  tenantLocatorType: string;
  tenantLocatorValue: string;
};

export type Store = { id: string; companyId: string; code: string; name: string; active: boolean };

export type ProviderAccount = {
  tenantId: string;
  providerName: 'elosgate';
  accountReference: string;
  apiBaseUrl: string;
  status: 'enabled' | 'disabled';
  version: number;
  storeCodes: string[];
  credentialConfigured: boolean;
  createdAt: string;
  updatedAt: string;
};

export const getCompanies = async (): Promise<Company[]> =>
  (await axiosClient.get('/companies')).data;

export const getStores = async (companyId: string): Promise<Store[]> =>
  (await axiosClient.get(`/companies/${companyId}/stores`)).data;

export const getProviderAccounts = async (companyId: string): Promise<ProviderAccount[]> =>
  (await axiosClient.get(`/companies/${companyId}/provider-accounts`)).data;

export const createProviderAccount = async (
  companyId: string,
  input: { accountReference: string; apiBaseUrl: string; apiKey: string; storeCodes: string[]; status: string }
): Promise<ProviderAccount> =>
  (await axiosClient.post(`/companies/${companyId}/provider-accounts`, input)).data;

export const updateProviderAccount = async (
  companyId: string,
  accountReference: string,
  input: { apiBaseUrl: string; apiKey?: string; storeCodes: string[]; status: string; expectedVersion: number }
): Promise<ProviderAccount> =>
  (await axiosClient.put(
    `/companies/${companyId}/provider-accounts/${encodeURIComponent(accountReference)}`,
    input
  )).data;
